module.exports = __webpack_public_path__ + "img/ring_r_0_null_null.bcdf52b8.png";